'use client';

import dynamic from 'next/dynamic';

export const AppLoadingBar = dynamic(
  () => import('./AppLoadingBar').then((mod) => mod.AppLoadingBar),
  { ssr: false }
);
